export default __webpack_public_path__ + "static/media/offer.inline.ea1a8547.svg";